
export const FETCH_CONTRACTOR_BILL_ENTRIES_REQUEST_DK = 'FETCH_CONTRACTOR_BILL_ENTRIES_REQUEST_DK';
export const FETCH_CONTRACTOR_BILL_ENTRIES_SUCCESS_DK = 'FETCH_CONTRACTOR_BILL_ENTRIES_SUCCESS_DK';
export const FETCH_CONTRACTOR_BILL_ENTRIES_FAILURE_DK = 'FETCH_CONTRACTOR_BILL_ENTRIES_FAILURE_DK';

export const CREATE_USER_FORM_CONTRACTOR_BILL_DK = 'CREATE_USER_FORM_CONTRACTOR_BILL_DK';

export const CREATE_USER_FORM_CONTRACTOR_BILL_DETAIL_DK = 'CREATE_USER_FORM_CONTRACTOR_BILL_DETAIL_DK';

export const CREATE_CONTRACTOR_BILL_ENTRIES_REQUEST = 'CREATE_CONTRACTOR_BILL_ENTRIES_REQUEST_DK';
export const CREATE_CONTRACTOR_BILL_ENTRIES_SUCCESS = 'CREATE_CONTRACTOR_BILL_ENTRIES_SUCCESS_DK';
export const CREATE_CONTRACTOR_BILL_ENTRIES_FAILURE = 'CREATE_CONTRACTOR_BILL_ENTRIES_FAILURE_DK';

export const FETCH_CONTRACTOR_BILL_SALES_ORDER_REQUEST = 'FETCH_CONTRACTOR_BILL_SALES_ORDER_REQUEST';
export const FETCH_CONTRACTOR_BILL_SALES_ORDER_SUCCESS = 'FETCH_CONTRACTOR_BILL_SALES_ORDER_SUCCESS';
export const FETCH_CONTRACTOR_BILL_SALES_ORDER_FAILURE = 'FETCH_CONTRACTOR_BILL_SALES_ORDER_FAILURE';

export const FETCH_CONTRACTOR_BILL_BANK_DETAILS_REQUEST = 'FETCH_CONTRACTOR_BILL_BANK_DETAILS_REQUEST';
export const FETCH_CONTRACTOR_BILL_BANK_DETAILS_SUCCESS = 'FETCH_CONTRACTOR_BILL_BANK_DETAILS_SUCCESS';
export const FETCH_CONTRACTOR_BILL_BANK_DETAILS_FAILURE = 'FETCH_CONTRACTOR_BILL_BANK_DETAILS_FAILURE';

export const CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK = 'CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK';
export const CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK = 'CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK';
export const CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK = 'CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK';

export const FETCH_SINGLE_CONTRACTOR_BILL_MASTER_REQUEST = 'FETCH_SINGLE_CONTRACTOR_BILL_MASTER_REQUEST';
export const FETCH_SINGLE_CONTRACTOR_BILL_MASTER_SUCCESS = 'FETCH_SINGLE_CONTRACTOR_BILL_MASTER_SUCCESS';
export const FETCH_SINGLE_CONTRACTOR_BILL_MASTER_FAILURE = 'FETCH_SINGLE_CONTRACTOR_BILL_MASTER_FAILURE';

export const FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_REQUEST = 'FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_REQUEST';
export const FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_SUCCESS = 'FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_SUCCESS';
export const FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_FAILURE = 'FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_FAILURE';

export const DELETE_CONTRACTOR_BILL_REQUEST = 'DELETE_CONTRACTOR_BILL_REQUEST';
export const DELETE_CONTRACTOR_BILL_SUCCESS = 'DELETE_CONTRACTOR_BILL_SUCCESS';
export const DELETE_CONTRACTOR_BILL_FAILURE = 'DELETE_CONTRACTOR_BILL_FAILURE';

export const UPDATE_CONTRACTOR_BILL_ENTRIES_REQUEST = 'UPDATE_CONTRACTOR_BILL_ENTRIES_REQUEST';
export const UPDATE_CONTRACTOR_BILL_ENTRIES_SUCCESS = 'UPDATE_CONTRACTOR_BILL_ENTRIES_SUCCESS';
export const UPDATE_CONTRACTOR_BILL_ENTRIES_FAILURE = 'UPDATE_CONTRACTOR_BILL_ENTRIES_FAILURE';

export const CONTRACTOR_BILL_ENTRY_USERFORM_RESET = 'CONTRACTOR_BILL_ENTRY_USERFORM_RESET';

export const CONTRACTOR_BILL_ENTRY_DETAIL_USERFORM_RESET = 'CONTRACTOR_BILL_ENTRY_DETAIL_USERFORM_RESET';

export const UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK = 'UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK';
export const UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK = 'UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK';
export const UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK = 'UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK';

export const FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_REQUEST = 'FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_REQUEST';
export const FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_SUCCESS = 'FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_SUCCESS';
export const FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_FAILURE = 'FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_FAILURE';

export const FETCH_CONTRACTOR_BILL_INVOICE_REQUEST = 'FETCH_CONTRACTOR_BILL_INVOICE_REQUEST';
export const FETCH_CONTRACTOR_BILL_INVOICE_SUCCESS = 'FETCH_CONTRACTOR_BILL_INVOICE_SUCCESS';
export const FETCH_CONTRACTOR_BILL_INVOICE_FAILURE = 'FETCH_CONTRACTOR_BILL_INVOICE_FAILURE';

export const RESET_CONTRACTOR_BILL_INVOICE = 'RESET_CONTRACTOR_BILL_INVOICE';


export const FETCH_CONTRACTOR_BILL_PRICE_REQUEST = 'FETCH_CONTRACTOR_BILL_PRICE_REQUEST';
export const FETCH_CONTRACTOR_BILL_PRICE_SUCCESS = 'FETCH_CONTRACTOR_BILL_PRICE_SUCCESS';
export const FETCH_CONTRACTOR_BILL_PRICE_FAILURE = 'FETCH_CONTRACTOR_BILL_PRICE_FAILURE';

export const FETCH_CONTRACTOR_BILL_PRICE_RESET = 'FETCH_CONTRACTOR_BILL_PRICE_RESET';





